import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resolucion } from '../models/t3_resolucion.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResolucionesService {

  constructor(private http: HttpClient) { }

  getToken(): string {
    return <string>localStorage.getItem('access_token');
  }

  // Método para crear headers con el token
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
  }

  // Métodos para paginación
  getPages(pageSize: number, usuario: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', usuario.Name);
    params = params.append('size', pageSize);
    params = params.append('SessionRecordId', usuario.SessionRecordId);
    return this.http.get<any>(`${environment.apiUrl}/resoluciones/paginar`, { headers, params });
  }

  getDataId(usuario: Resolucion): Observable<Resolucion> {
    const headers = this.getHeaders();
    return this.http.get<Resolucion>(`${environment.apiUrl}/resoluciones/${usuario.Id}`, { headers });
  }

  getDataFilter(page: any, filtro: Resolucion): Observable<Resolucion[]> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', filtro.Name);
    params = params.append('SessionRecordId', filtro.SessionRecordId);
    if(page!=0){
      params = params.append('size', page.size);
      params = params.append('offset', page.offset);
    }
    return this.http.get<Resolucion[]>(`${environment.apiUrl}/resoluciones`, { headers, params });
  }

  postData(demostracion: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(demostracion));
    formData.append('file', demostracion.File || '');
    return this.http.post<any>(`${environment.apiUrl}/resoluciones`, formData, { headers });
  }

  putData(usuario: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(usuario));
    formData.append('file', usuario.File || '');
    return this.http.put<any>(`${environment.apiUrl}/resoluciones/${usuario.Id}`, formData, { headers });
  }

  deleteData(usuario: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete<any>(`${environment.apiUrl}/resoluciones/${usuario.Id}`, { headers });
  }



  postSubirData(resolucionesCargadas: Resolucion[]): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    // Agregar los datos de las resoluciones
    formData.append('data', JSON.stringify(resolucionesCargadas));
    // Agregar cada archivo PDF con un nombre único
    resolucionesCargadas.forEach((resolucion, index) => {
      if (resolucion.File) {
        formData.append(`files[]`, resolucion.File, resolucion.File.name);
      }
    });
    return this.http.post<any>(`${environment.apiUrl}/resoluciones/importar/subir`, formData, { headers });
  }

  postProcesarArchivos(resolucionesCargadas: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    // Agregar metadatos
    resolucionesCargadas.LoadEstate = 0; // Pendiente
    formData.append('data', JSON.stringify(resolucionesCargadas));
    return this.http.post<any>(`${environment.apiUrl}/resoluciones/importar/procesar`, formData, { headers });
  }

  postGuardarData(demostracion: Resolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(demostracion));
    return this.http.post<any>(`${environment.apiUrl}/resoluciones/importar/guardar`, formData, { headers });
  }

}
